<div class="help-center-container">
  <umkt-faq-section 
    [title]="'pages.helpCenter.title' | i18n"
    [description]="'pages.helpCenter.description' | i18n">
  </umkt-faq-section>
</div>
